import Dashboard from '@/agilis/components/Dashboard/Dashboard.vue'
import dataMixin from '@/agilis/components/Dashboard/mixin/dataMixin'

export default {
  name: 'AppDashboard',
  mixins: [
    dataMixin
  ],

  components: {
    Dashboard
  }
}
